import { afterGet as globalAfterGet } from "services/sosInventoryService/afterGet";
import { productionTransactionAfterGet } from "services/sosInventoryService/productionTransaction/afterGet";
import { FIELDS_TO_TRANSFORM } from "services/sosInventoryService/workOrder/schema";
import {
  transformFields,
  transformLineItemFields,
} from "services/utility/afterGet";

import { OBJECT_TYPES } from "appConstants";
import { LINE_ITEM_FIELDS } from "editConfig";

const OBJECT_TYPE = OBJECT_TYPES.WORK_ORDER.fullString;

export function afterGet(record) {
  let newRecord = transformFields(record, FIELDS_TO_TRANSFORM);

  newRecord.lines = transformLineItemFields(
    newRecord.lines,
    LINE_ITEM_FIELDS[OBJECT_TYPE]
  );

  newRecord = productionTransactionAfterGet(newRecord);
  return globalAfterGet(newRecord);
}
